import {useFormContext} from "react-hook-form";

import {FormSubtext} from "@/components/formSubtext/FormSubtext.tsx";
import {Input} from "@/components/input/Input.tsx";
import {getFormError} from "@/lib/form/form.utils.ts";

interface DurationFieldProps {
  name: string;
}

export const DurationField = ({name}: DurationFieldProps) => {
  const {
    watch,
    setValue,
    clearErrors,
    formState: {errors},
  } = useFormContext();

  const fieldError = getFormError(name, errors);
  const escalationError = errors?.escalations?.message?.toString();

  const value = watch(name);
  const hValue = Math.floor(value / 60);
  const mValue = value % 60;
  return (
    <div className="d-flex flex-column">
      <div className="d-flex justify-content-between align-items-top">
        <div className="text-center">
          <Input
            name={`${name}.hours`}
            type="text"
            className="form-control text-center"
            placeholder="hhh"
            value={hValue ? hValue : ""}
            onChange={(e) => {
              if (escalationError) {
                clearErrors("escalations");
              }
              setValue(name, parseInt(e.target.value || "0") * 60 + mValue, {shouldDirty: true, shouldValidate: true});
            }}
            maxLength={3}
            max={999}
          />
          <div className="pulseTextBodySmall pulse-color-gray-700 mt-1">hours</div>
        </div>
        <span className="mt-2">&nbsp;:&nbsp;</span>
        <div className="text-center">
          <Input
            name={`${name}.mins`}
            type="text"
            className="form-control text-center"
            placeholder="mm"
            value={mValue ? mValue : ""}
            onChange={(e) => {
              if (escalationError) {
                clearErrors("escalations");
              }
              const value = parseInt(e.target.value || "0");
              if (value < 60) {
                setValue(name, value + hValue * 60, {shouldDirty: true, shouldValidate: true});
              }
            }}
            maxLength={2}
            max={59}
          />
          <div className="pulseTextBodySmall pulse-color-gray-700 mt-1">mins</div>
        </div>
      </div>
      <FormSubtext error={fieldError?.toString()} />
    </div>
  );
};
